<template>
    <div>
        <h5 class="grey-color fw-600">Выбор поставщика</h5>
        <b-table :fields="fields" :items="proposals" :class="{ 'is-table-invalid': v && v.$invalid }" class="table-atmo overflow-hidden mb-2" small responsive>
            <template #cell(index)="data">
                {{ data.index + 1 }}
            </template>
            <template #cell(status)="data">
                {{ data.item.status.title }} <span v-if="data.item.is_my_proposal" v-text="'(Моё)'" />
            </template>
            <template #cell(created_at)="data">
                {{ $formatDateTime(data.item.created_at) }}
            </template>
            <template #cell(organization)="data">
                <b-icon-award v-if="data.item.id === selectedProposalId" style="color: var(--orange);" title="Выбран победителем" />&nbsp;
                <router-link class="atmo-button-link" target="_blank" :to="{ name: 'OrganizationShow', params: { id: data.item.organization.id } }">{{ data.item.organization.name }}</router-link>
            </template>
            <template #cell(rating)="data">
                {{ $formatPrice(data.item.organization.rating) }}
            </template>
            <template #cell(actions)="data">
                <action-button-small icon="clipboard-check" title="Информация о подписи" @click="showSign(false, data.item.signature)" />
                <action-button-small v-if="data.item.signature.poa_number && data.item.signature.poa_check_link" class="ml-1" icon="clipboard-plus" title="Информация о МЧД" variant="warning" @click="showSign(false, data.item.signature)" />
                <action-button-small icon="cloud-download" title="Скачать xml файл" variant="outline" class="ml-1" @click="downloadXml(data.item.signature.xml, false, `proposal_${data.item.id}`)" />
                <b-button :disabled="data.item.id === selectedProposalId" class="btn-card-action btn-card-action-green text-uppercase ml-1" style="height: 24px; padding-top: 5px !important; padding-bottom: 5px !important;" @click="selectProposal(data.item.id)">Выбрать</b-button>
            </template>
        </b-table>
        <b-form-invalid-feedback :state="v && !v.$invalid">Необходимо выбрать поставщика</b-form-invalid-feedback>
        <show-sign-modal v-if="signData.signature" :signature="signData.signature" :org-is-customer="signData.isCustomer" :show="showSignModal" @close="showSignModal = false" />
    </div>
</template>

<script>

import { encodeBase64, saveAs } from '@progress/kendo-file-saver';
import { required } from 'vuelidate/lib/validators';

export default {
    name: 'fl44-unknown-volume-select-second-proposal-table',
    props: {
        value: {
            type: Number,
            default: null,
        },
        proposals: {
            type: Array,
            required: true
        },
        v: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            signData: {
                signature: null,
                isCustomer: false
            },
            fields: [
                { key: 'index', label: '№', tdClass: 'align-text-top text-nowrap py-1', thClass: 'py-1', thStyle: { width: '1px' } },
                { key: 'organization', label: 'Поставщик', tdClass: 'align-text-top py-1', thClass: 'py-1', thStyle: { width: '490px' } },
                { key: 'status', label: 'Статус', tdClass: 'align-text-top py-1', thClass: 'text-nowrap py-1' },
                { key: 'created_at', label: 'Дата и время подачи', tdClass: 'align-text-top py-1 text-nowrap', thClass: 'py-1', thStyle: { width: '155px' } },
                { key: 'rating', label: 'Рейтинг ИС', tdClass: 'align-text-top text-center py-1 text-nowrap', thClass: 'text-center py-1', thStyle: { width: '100px' } },
                { key: 'actions', label: '', tdClass: 'align-text-top py-1 text-nowrap text-right', thClass: 'py-1 text-nowrap text-right', thStyle: { width: '1px' } }
            ],
        };
    },
    methods: {
        selectProposal(proposalId) {
            this.selectedProposalId = proposalId;
        },
        showSign(isCustomer, signature) {
            this.signData.isCustomer = isCustomer;
            this.signData.signature = signature;
            this.showSignModal = true;
        },
        downloadXml(signature, isCustomer, fileName) {
            const downloadData = 'data:text/plain;base64,' + encodeBase64(signature);
            const downloadFileName = (isCustomer ? 'customer_' : 'supplier_') + fileName + '.xml';
            saveAs(downloadData, downloadFileName);
        }
    },
    validations() {
        return {
            selectedProposalId: { required },
        }
    },
    computed: {
        selectedProposalId: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value);
            }
        }
    }
};
</script>

<style scoped>
.is-table-invalid {
    border: 1px solid red;
    border-radius: 4px;
}
</style>
